export default __webpack_public_path__ + "static/banner-europe-train-9fc8e0bc6d152488931b922dba36dc53.jpg";